export default function PHP_ssl_set() {
  return (
    <div>
      <h1>PHP_ssl_set</h1>
    </div>
  );
}
